import { useEffect, useState } from 'react'
import { supabase } from '../../../lib/supabase'
import AdminLayout from '../components/AdminLayout'
import FixturesTable from './components/FixturesTable'
import FixtureForm from './components/FixtureForm'
import LoadingSpinner from '../../../components/LoadingSpinner'

export default function AdminFixtures() {
  const [fixtures, setFixtures] = useState([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [editing, setEditing] = useState(null)

  const fetchFixtures = async () => {
    const { data } = await supabase
      .from('fixtures').select('*')
      .eq('club_id', 'a0000000-0000-0000-0000-000000000001')
      .order('match_date', { ascending: false })
    if (data) setFixtures(data)
    setLoading(false)
  }

  useEffect(() => { fetchFixtures() }, [])

  return (
    <AdminLayout>
      <div className="mb-6 lg:mb-8 flex justify-between items-center gap-4">
        <div>
          <h1 className="text-2xl lg:text-4xl font-black uppercase tracking-tight mb-2 text-gray-900 dark:text-white">Fixtures</h1>
          <p className="text-gray-500 text-sm">{fixtures.length} fixtures this season</p>
        </div>
        <button
          onClick={() => { setEditing(null); setShowForm(true) }}
          className="bg-green-600 hover:bg-green-700 text-white px-4 sm:px-6 py-3 font-bold uppercase tracking-widest text-xs sm:text-sm transition-colors whitespace-nowrap"
        >
          Add Fixture
        </button>
      </div>

      {loading ? (
        <LoadingSpinner fullScreen message="Loading fixtures..." />
      ) : (
        <FixturesTable
          fixtures={fixtures}
          onEdit={(fixture) => { setEditing(fixture); setShowForm(true) }}
          onRefresh={fetchFixtures}
        />
      )}

      {showForm && (
        <FixtureForm
          fixture={editing}
          onClose={() => { setShowForm(false); setEditing(null) }}
          onRefresh={fetchFixtures}
        />
      )}
    </AdminLayout>
  )
}